module.exports = __webpack_public_path__ + "img/date.37ce2044.svg";